import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getActivities = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/activities?' + params.toString()); // include=opportunity&
};

const getActivityById = async (id: number) => {
  return await apiClient.get(`/activities/${id}`); // Fetch car listing by ID
};

const createActivity = async (activityData: any) => {
  return await apiClient.post('/activities', activityData); // Create a new car listing
};

const updateActivity = async (id: number, activityData: any) => {
  return await apiClient.patch(`/activities/${id}`, activityData); // Update car listing by ID
};

const deleteActivity = async (id: number) => {
  return await apiClient.delete(`/activities/${id}`); // Delete car listing by ID
};

const rescheduleActivity = async (id: number, data: any) => {
  return await apiClient.post(`/activities/reschedule/${id}`, data);
};

const exportCSV = async (params: string, body: any) => {
  return await apiClient.post(`/activities/export?${params}`, body, {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  });
};

export default {
  getActivities,
  getActivityById,
  createActivity,
  updateActivity,
  deleteActivity,
  rescheduleActivity,
  exportCSV
};
